import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useParams } from "react-router-dom";
import LoaderContainer from "../../components/LoaderContainer";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import { useLocation } from "react-router-dom";
export default function ViewLoanProposal() {
  const { proposalId } = useParams();
  const { t } = useTranslation();

  const [loanDetails, setLoanDetails] = useState({});
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const searchParams = new URLSearchParams(location.search);
  const [docsRequired, setDocsRequired] = useState([]);
  const loan_request_id = searchParams.get("loan-request-id");

  useEffect(() => {
    if (loan_request_id === null) {
      api
        .get(`/lending/get-loan-request-list?loan_id=${proposalId}`)
        .then((response) => {
          setLoanDetails(response.data);
          setDocsRequired(response.data.required_documents);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching lenders:", error);
        });
    } else {
      api
        .get(`/lending/get-loan-proposal?proposalId=${proposalId}`)
        .then((response) => {
          setLoanDetails(response.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching lenders:", error);
        });
    }
  }, []);

  const infoItems = loanDetails
    ? [
        {
          label: "Interest Rate",
          value:
            loan_request_id === null
              ? `${loanDetails.interest_rate_min}% -${loanDetails.interest_rate_max}`
              : `${loanDetails.loan_proposal?.rate}%`,
        },
        {
          label: "Loan Amount",
          value:
            loan_request_id === null
              ? `Rs.${loanDetails.loan_amount}`
              : `Rs.${loanDetails.loan_proposal?.amount}`,
        },
        {
          label: "Loan Tenure",
          value:
            loan_request_id === null
              ? `Up To ${loanDetails.loan_tenure_months} months`
              : `Up To ${loanDetails.lender_generic_offer?.loan_tenure_months} months`,
        },
        {
          label: "Minimum Revenue Required",
          value:
            loan_request_id === null
              ? `${loanDetails.minimum_revenue}`
              : `${loanDetails.lender_generic_offer?.minimum_revenue}`,
        },
      ]
    : [];

  const handleAccept = () => {
    if (loan_request_id !== "undefined") {
      api
        .post(
          `/lending/loan-proposal/${proposalId}/borrower-accept/?loan_request_id=${loan_request_id}`
        )
        .then((response) => {
          console.log(response);
          alert("Offer Accepted");
          window.location.href = "/fpo/loans";
        });
    } else {
      api
        .post(`/lending/loan-proposal/${proposalId}/borrower-accept/`)
        .then((response) => {
          console.log(response);
          alert("Offer Accepted");
          window.location.href = "/fpo/loans";
        });
    }
  };

  const handleReject = () => {
    api
      .post(`/lending/loan-proposal/${proposalId}/borrower-reject/`)
      .then((response) => {
        console.log(response);
        alert("Offer Rejected");
        window.location.href = "/fpo/loans";
      });
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <Grid container style={{ marginTop: "10px" }}>
            {/* <CustomTitle>{lenderName}</CustomTitle> */}

            {loanDetails && (
              <>
                <div
                  style={{
                    height: "76vh",
                    width: "100%",
                    marginTop: "20px",
                    overflowY: "scroll",
                  }}
                >
                  {/* <img src={lender.lender_logo} height="auto" width="200" /> */}
                  <img
                    src={
                      loanDetails.lender_generic_offer
                        ? loanDetails.lender_generic_offer.lender_logo
                        : loanDetails.lender_logo
                    }
                    alt="Lender Logo"
                    style={{
                      width: "100%",
                      height: "40%",
                      objectFit: "contain",
                    }}
                  />

                  <Box sx={{ marginTop: "15%" }}>
                    {infoItems.map((item, index) => (
                      <Grid container spacing={1} key={index}>
                        <Grid item xs={6}>
                          <Typography variant="body1" fontWeight="bold">
                            {item.label}:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body1">{item.value}</Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Box>

                  <Box sx={{ marginTop: "10%" }}>
                    <Typography variant="body1" fontWeight="bold">
                      {t("Documents Required")}
                    </Typography>
                    <ul>
                      {docsRequired.map((item) => (
                        <li key={item.name}>
                          <Typography variant="body1" fontWeight="bold">
                            {item.name}
                          </Typography>
                        </li>
                      ))}
                    </ul>
                  </Box>
                </div>
              </>
            )}
            {loanDetails.loan_proposal?.borrower_status === "pending" && (
              <>
                <div style={{ width: "100%" }}>
                  <CustomButton onClick={handleAccept} hideIcon>
                    {t("Accept")}
                  </CustomButton>
                </div>
                <div style={{ width: "100%" }}>
                  <CustomButton
                    onClick={handleReject}
                    hideIcon
                    backgroundColor="#CF5C5C"
                  >
                    {t("Reject")}
                  </CustomButton>
                </div>
              </>
            )}
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
